import { useState, useEffect, useMemo, useContext } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import SignIn from './cloudtern/components/Dashboard/SignIn';
import SignUp from './cloudtern/components/Dashboard/SignUp';
import OAuthCallback from "./cloudtern/components/Dashboard/OAuthCallback";
import Error from "cloudtern/components/Dashboard/Error";
import notfoundimage from "./assets/images/404-image.svg";
import { Box, CircularProgress, keyframes } from "@mui/material";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import Error1 from "cloudtern/components/Dashboard/Error1";
import { useSoftUIController, setMiniSidenav, setOpenConfigurator, setLayout, SoftUIControllerProvider } from "context";

import brand from "assets/images/Anser.png";
import { RoutesContext } from "context/RoutesContext";

import Dashboard from './cloudtern/components/Dashboard';
import Users from 'cloudtern/components/Users';
import Searches from 'cloudtern/components/Searches';
import Likes from "cloudtern/components/Likes";
import Dislikes from 'cloudtern/components/Dislikes';
import Unanswered_questions from "cloudtern/components/Unanswered_questions";
import TotalEmails from "cloudtern/components/Emails";
import ContactUsActions from "cloudtern/components/ContactUs";

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';

import WebflowLayout from "cloudtern/components/Webflow/WebflowLayout";
import Settings from "cloudtern/components/Settings";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { useAuth } from "context/AuthContext";
import Registration from "cloudtern/components/Webflow/Registration";
import NotFound from "cloudtern/components/Webflow/NotFound";
import { Button, Card, CardContent, Typography } from "@mui/material";
import AnseraLogo from "assets/images/Anser.png";
import ConfirmPassword from "cloudtern/components/Webflow/ConfirmPassword";
import Signup from "cloudtern/components/Webflow/Signup";
import Customers from "cloudtern/components/CustomerSites";
import Pricing from "cloudtern/components/Dashboard/Pricing";
import { AccountTree, Brush, Equalizer, GraphicEq, IntegrationInstructions, Merge, MonetizationOn, QueryStats } from "@mui/icons-material";
import Onboarding from "cloudtern/components/Webflow/Onboarding";
import DomainsBySource from "cloudtern/components/Webflow/DomainsBySource";
import Integrations from "cloudtern/components/Webflow/integrationsNew";
import AeoChecker from "cloudtern/components/Aeo/AeoChecker";
import WhitelabelBrandingPage from "cloudtern/components/CustomerSites/WhitelabelBrandingContainer";
import { BrushIcon } from "lucide-react";
import MergeDomainsSection from "cloudtern/components/CustomerSites/MergeDomains";

import { SystemThemeProvider, useSystemTheme } from "context/SystemThemeContext";
import Auth from "cloudtern/components/Auth";

// Import session manager

import { getAccessToken, clearAccessToken } from "utils/tokenManager";
import axiosInstance from "utils/axiosConfig";
import { FAST_API_BASE_URL } from "constants";
import { useSessionManager } from "cloudtern/components/Auth/hooks/useSessionManager";
import { SessionWarningDialog } from "cloudtern/components/SessionWarningDialog";

const AppContent = () => {
  const { theme } = useSystemTheme();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const { queryString } = useContext(RoutesContext);
  const { user, isAuthenticated, getCurrentRole, loading, isInitialized,currentDomain ,showRebrandingPage,showMergeDomainsPage,logout } = useAuth();
  const role = getCurrentRole() || sessionStorage.getItem("role");

  const {isWarningVisible,countdownSeconds,extendSession} = useSessionManager();

  const dashboardRoutes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      icon: <SpaceDashboardRoundedIcon size="12px" />,
      noCollapse: true,
      component: <Dashboard key="dashboard" />,
    },
    {
      type: "collapse",
      name: "Visitors",
      key: "visitors",
      route: "/visitors",
      icon: <PeopleAltRoundedIcon fontSize="10px" />,
      noCollapse: true,
      component: <Users key="visitors" />
    },
    {
      type: "collapse",
      name: "Queries",
      key: "queries",
      route: "/queries",
      icon: <SearchRoundedIcon fontSize="10px" />,
      noCollapse: true,
      component: <Searches key="queries" />
    },
    {
      type: "collapse",
      name: "Likes",
      key: "likes",
      route: "/likes",
      icon: <ThumbUpOutlinedIcon size="10px" />,
      noCollapse: true,
      component: <Likes key="likes" />,
    },
    {
      type: "collapse",
      name: "Dislikes",
      key: "dislikes",
      route: "/dislikes",
      icon: <ThumbDownAltOutlinedIcon size="10px" />,
      noCollapse: true,
      component: <Dislikes key="dislikes" />
    },
    {
      type: "collapse",
      name: "Unanswered",
      key: "unanswered",
      route: "/unanswered",
      icon: <ErrorOutlineIcon size="10px" />,
      noCollapse: true,
      component: <Unanswered_questions key="unanswered" />
    },
    {
      type: "collapse",
      name: "Emails Sent",
      key: "emails-sent",
      route: "/emails-sent",
      icon: <MailOutlineIcon size="10px" />,
      noCollapse: true,
      component: <TotalEmails key="emails-sent" />
    },
    {
      type: "collapse",
      name: "Contact Us Actions",
      key: "contact-us",
      route: "/contact-us",
      icon: <PermContactCalendarIcon size="10px" />,
      noCollapse: true,
      component: <ContactUsActions key="contact-us" />
    },
  ];

  if (isAuthenticated() && (role === "read&write" || role === "admin")) {
    dashboardRoutes.push({
      type: "collapse",
      name: "Integrations",
      key: "integrations",
      icon: <AccountTree size="10px" />,
      route: "/integrations",
      noCollapse: true,
      component: <Integrations key="integrations" />,
    });
    dashboardRoutes.push({
      type: "collapse",
      name: "AEO ",
      key: "aeo",
      icon: <QueryStats size="10px" />,
      route: "/aeo",
      noCollapse: true,
      component: <AeoChecker key="aeo" />,
    });
  }
  if (isAuthenticated() && (role === "read&write" || role === "admin" || user?.is_super_admin === true || localStorage.getItem("is_super_admin") === "true")) {
      dashboardRoutes.push({
      type: "collapse",
      name: "Settings",
      key: "settings",
      icon: <SettingsSuggestIcon size="10px" />,
      route: "/settings",
      noCollapse: true,
      component: <Settings key="settings" />,
    });
  }

  if (user?.is_super_admin === true || localStorage.getItem("is_super_admin") === "true") {
    dashboardRoutes.unshift({
      type: "collapse",
      name: "Customers",
      key: "customers",
      icon: <PeopleAltRoundedIcon fontSize="10px" />,
      route: "/customers",
      noCollapse: true,
      component: <Customers key="customers" />,
    });
    
    dashboardRoutes.unshift({
      type: "collapse",
      name: "Website Build",
      key: "website-build",
      icon: <Equalizer fontSize="10px" />,
      route: "/website-build",
      noCollapse: true,
      component: <DomainsBySource key="website-build" />,
    });
  }

  if(showRebrandingPage){
    dashboardRoutes.push({   
      type: "collapse",
      name: "Rebranding",
      key: "rebranding",
      route: "/rebranding",
      icon: <Brush size="10px" />,
      noCollapse: true,
      component: <WhitelabelBrandingPage key="rebranding" />
    })
  }
  if(showMergeDomainsPage){
    dashboardRoutes.push({   
      type: "collapse",
      name: "Merge Domains",
      key: "merge-domains",
      route: "/merge-domains",
      icon: <Merge size="10px" />,
      noCollapse: true,
      component: <MergeDomainsSection key="merge-domains" />
    })
  }
  const webflowRoutes = [
    {
      type: "collapse",
      name: "layouts",
      key: "layouts",
      route: "/layouts",
      icon: <i className="fas fa-rocket" />,
      noCollapse: true,
      component: <WebflowLayout />
    }
  ];

  const getCurrentRoutes = () => {
    switch (layout) {
      case "webflow":
        return webflowRoutes;
      case "dashboard":
      default:
        return dashboardRoutes;
    }
  };

  const routes = getCurrentRoutes();

  useEffect(() => {
    if (
      pathname === "/onboarding" ||
      pathname === "/login" ||
      pathname === "/" ||
      pathname.startsWith("/login/")
    ) {
      setLayout(dispatch, "webflow");
    } else if (
      pathname.startsWith("/dashboard") ||
      pathname.startsWith("/visitors") ||
      pathname.startsWith("/queries") ||
      pathname.startsWith("/likes") ||
      pathname.startsWith("/dislikes") ||
      pathname.startsWith("/unanswered") ||
      pathname.startsWith("/emails-sent") ||
      pathname.startsWith("/contact-us") ||
      pathname.startsWith("/settings") ||
      pathname.startsWith("/customers") ||
      pathname.startsWith("/website-build") ||
      pathname.startsWith("/integrations") ||
      pathname.startsWith("/aeo") ||
      pathname.startsWith("/rebranding") ||
      pathname.startsWith("/merge-domains")
    ) {
      setLayout(dispatch, "dashboard");
    }
  }, [pathname, dispatch]);

  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });
    setRtlCache(cacheRtl);
  }, []);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) return getRoutes(route.collapse);
      if (route.route) return <Route exact path={route.route} element={route.component} key={route.key} />;
      return null;
    });

  const getAllRoutes = () => [...dashboardRoutes, ...webflowRoutes];

  const getAllRoutePaths = () => {
    const flattenRoutes = (routesList) => {
      return routesList.reduce((acc, route) => {
        if (route.route) acc.push(route.route);
        if (route.collapse) acc.push(...flattenRoutes(route.collapse));
        return acc;
      }, []);
    };
    return flattenRoutes(getAllRoutes());
  };

  const allValidPaths = getAllRoutePaths();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userParam = params.get("user");
    if (userParam) {
      const parsedUser = JSON.parse(userParam);
      console.log("User from URL:", parsedUser);
    }
  }, []);

  const HIDE_SIDENAV_ROUTES = [
    "/", "/sign-in", "/sign-up", "/oauth-callback", "/login", 
    "/onboarding", "/Access-Denied", "/error", "/register", "/404",
    "/set-password", "/signup"
  ];
  
  const navigate = useNavigate();
  const isLoginWithReferral = pathname.startsWith("/login/");
  
  useEffect(() => {
    const handleSessionExpired = () => {
      console.log("Session expired - redirecting to login");
      logout();
      navigate("/login");
    };
    
    window.addEventListener('sessionExpired', handleSessionExpired);
    
    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, [logout, navigate]);

  const renderLayoutComponents = () => {
    const isHiddenRoute = HIDE_SIDENAV_ROUTES.includes(pathname) || isLoginWithReferral;

    const isValidRoute = allValidPaths.includes(pathname);
const pulse = keyframes`
  0% {
    opacity: 0.6;
    transform: scale(0.95);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.6;
    transform: scale(0.95);
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

    if (loading || !isInitialized) {
      return (
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              background: theme.palette.mode === "dark" 
                ? "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)"
                : "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                overflow: "hidden",
              }}
            >
              {[...Array(3)].map((_, i) => (
                <Box
                  key={i}
                  sx={{
                    position: "absolute",
                    width: `${300 + i * 150}px`,
                    height: `${300 + i * 150}px`,
                    borderRadius: "50%",
                    background: `rgba(255, 255, 255, ${0.03 - i * 0.01})`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animation: `${pulse} ${8 + i * 2}s ease-in-out infinite`,
                  }}
                />
              ))}
            </Box>

            <Box
              sx={{
                textAlign: "center",
                zIndex: 1,
                animation: `${slideUp} 0.5s ease-out`,
              }}
            >
              <Box
                sx={{
                  mb: 4,
                  animation: `${pulse} 2s ease-in-out infinite`,
                }}
              >
                <img
                  src={AnseraLogo}
                  alt="Ansera AI"
                  style={{
                    height: "60px",
                    filter: theme.palette.mode === "dark" 
                      ? "brightness(0) invert(1)" 
                      : "brightness(0) invert(0)",
                  }}
                />
              </Box>

              <Box sx={{ position: "relative", display: "inline-block", mb: 3 }}>
                <CircularProgress
                  size={60}
                  thickness={4}
                  sx={{
                    color: theme.palette.mode === "dark" ? "#219197" : "#219297",
                    animation: `${rotate} 1.5s linear infinite`,
                  }}
                />
                <CircularProgress
                  size={80}
                  thickness={2}
                  sx={{
                    color: theme.palette.mode === "dark" ? "#3ca9af" : "#219297",
                    position: "absolute",
                    top: -10,
                    left: -10,
                    animation: `${rotate} 2s linear infinite reverse`,
                  }}
                />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  color: theme.palette.mode === "dark" ? "#ffffff" : "#219297",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                  mb: 1,
                  animation: `${pulse} 1.5s ease-in-out infinite`,
                }}
              >
                Loading...
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                {[0, 0.2, 0.4].map((delay, i) => (
                  <Box
                    key={i}
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      bgcolor: theme.palette.mode === "dark" ? "#ffffff" : "#219297",
                      animation: `${pulse} 1s ease-in-out infinite`,
                      animationDelay: `${delay}s`,
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </MuiThemeProvider>
      );
    }

    if (isHiddenRoute ) return null;
    if(!isValidRoute){
      return(
        <div style={{ display: "flex", justifyContent: "center", marginTop: "5rem" }}>
          <Card sx={{ 
            maxWidth: 400, 
            textAlign: "center", 
            padding: "2rem",
            bgcolor: "background.paper",
          }}>
            <img 
              src={notfoundimage} 
              alt="Not Found"
              style={{
                filter: theme.palette.mode === "dark" ? "brightness(0.8)" : "none"
              }}
            />
            <CardContent>
              <img 
                src={AnseraLogo} 
                alt="Ansera Ai" 
                style={{
                  height: "30px",
                  width: "60px",
                  filter: theme.palette.mode === "dark" ? "brightness(0) invert(1)" : "none"
                }}
              />
              <Typography variant="body1" gutterBottom sx={{ color: "text.primary" }}>
                The page you are looking for does not exist.
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate("/dashboard")}
                sx={{
                  padding: "10px 10px",
                  borderRadius: "8px",
                  backgroundColor: "#219297",
                  color: "#ffffff",
                  fontWeight: "bold",
                  '&:hover': {
                    backgroundColor: "#177a80",
                  }
                }}
              >
                Go Home
              </Button>
            </CardContent>
          </Card>
        </div>
      )
    }
    
    switch (layout) {
      case "dashboard":
      case "webflow":
        return (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName=" "
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
          </>
        );
      default:
        return null;
    }
  };

  // Handle RTL vs LTR
  if (direction === "rtl") {
    return (
      <CacheProvider value={rtlCache}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <SessionWarningDialog
            open={isWarningVisible}
            countdownSeconds={countdownSeconds}
            onKeepAlive={extendSession}
            onLogout={async () => {
              try {
                const accessToken = getAccessToken();
                if (accessToken) {
                  await axiosInstance.post(`${FAST_API_BASE_URL}/api/auth/logout`, {}, {
                    headers: { 'Authorization': `Bearer ${accessToken}` },
                    withCredentials: true
                  });
                }
              } catch (error) {
                console.error("Logout API error:", error);
              }
              clearAccessToken();
              logout();
              navigate("/login");
            }}
          />
          {renderLayoutComponents()}
          <Routes>
            {getRoutes(getAllRoutes())}
            <Route path="/login/:referralCode?" element={<Auth />} />
            <Route path="/" element={<Auth />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/set-password" element={<ConfirmPassword />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/oauth-callback" element={<OAuthCallback />} />
            <Route path="/Access-Denied" element={<Error />} />
            <Route path="/error" element={<Error1 />} />
            <Route path="/404" element={<NotFound />} />
          </Routes>
        </MuiThemeProvider>
      </CacheProvider>
    );
  }

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <SessionWarningDialog
        open={isWarningVisible}
        countdownSeconds={countdownSeconds}
        onKeepAlive={extendSession}
        onLogout={async () => {
          try {
            const accessToken = getAccessToken();
            if (accessToken) {
              await axiosInstance.post(`${FAST_API_BASE_URL}/api/auth/logout`, {}, {
                headers: { 'Authorization': `Bearer ${accessToken}` },
                withCredentials: true
              });
            }
          } catch (error) {
            console.error("Logout API error:", error);
          }
          clearAccessToken();
          logout();
          navigate("/login");
        }}
      />
      {renderLayoutComponents()}
      <Routes>
        {getRoutes(getAllRoutes())}
        <Route path="/" element={<Auth />} />
        <Route path="/login/:referralCode?" element={<Auth />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/set-password" element={<ConfirmPassword />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/oauth-callback" element={<OAuthCallback />} />
        <Route path="/Access-Denied" element={<Error />} />
        <Route path="/error" element={<Error1 />} />
        <Route path="/404" element={<NotFound />} />
      </Routes>
    </MuiThemeProvider>
  );
};

export default function App() {
  return (
    <SystemThemeProvider>
      <SoftUIControllerProvider>
        <AppContent />
      </SoftUIControllerProvider>
    </SystemThemeProvider>
  );
}